import { render, staticRenderFns } from "./HousingPreview.vue?vue&type=template&id=47e04676&scoped=true&"
import script from "./HousingPreview.vue?vue&type=script&lang=js&"
export * from "./HousingPreview.vue?vue&type=script&lang=js&"
import style0 from "./HousingPreview.vue?vue&type=style&index=0&id=47e04676&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e04676",
  null
  
)

export default component.exports